import { render } from "./IconTruck.vue?vue&type=template&id=05d64cd1"
import script from "./IconTruck.vue?vue&type=script&lang=ts"
export * from "./IconTruck.vue?vue&type=script&lang=ts"
script.render = render

export default script